<template>
    <v-row>
        <template>
            <load-image-dialog :LoadImageDialogProps="LoadImageDialogProps" :companyId="companyId"/>
        </template>
        <template>
            <load-video-dialog :LoadVideoDialogProps="LoadVideoDialogProps" :companyId="companyId"/>
        </template>
        <v-row>
            <v-col
                v-for="(item, index1) in flowCmpnts"
                :key="index1"
                class="pt-10"
                cols="10"
                offset="1"
            >
                <v-row>
                    <v-col cols="4" offset="4">
                        <v-select
                            v-model="item.selectContentType"
                            :items="contentTypes"
                            label="Elige el tipo de contenido"
                            id="contentType"
                            solo
                        ></v-select>
                    </v-col>
                    <v-col v-if="index1 >= 1" >
                        <v-btn
                            @click="removeFlowBlock(index1)"
                            dark
                            fab
                            small
                            icon
                            color="grey"
                        ><v-icon>{{deleteIcon}}</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col v-else-if="index1 === 0 && item.selectContentType !== ''" >
                        <v-btn
                            @click="removeFlowBlock(index1)"
                            dark
                            fab
                            small
                            icon
                            color="grey"
                        ><v-icon>{{deleteIcon}}</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pt-0">
                        <v-card v-if="item.selectContentType === 'Descripción'">
                            <v-row class="pb-3">
                                <v-col cols="12">
                                    <v-row>
                                        <v-col>
                                            <v-card-title>
                                                <h3>Título</h3>
                                            </v-card-title>
                                            <v-row>
                                                <v-col class="mb-4" cols="8" offset="2">
                                                    <v-text-field
                                                        v-model="item.title"
                                                        name="title"
                                                        label="Agrega el título"
                                                        :counter="max3"
                                                        :rules="[rules.counter3, rules.required]"
                                                        type="text"
                                                        outlined
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-card-title>
                                                <h3>Descripción</h3>
                                            </v-card-title>
                                            <v-row>
                                                <v-col class="mb-4 pl-3 pr-3" cols="8" offset="2">
                                                    <v-textarea
                                                        v-model="item.description"
                                                        name="description"
                                                        label="Agrega la descripción"
                                                        :counter="max2"
                                                        :rules="[rules.counter2, rules.required]"
                                                        multi-line
                                                        outlined
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row class="pl-8 pr-8">
                                        <v-col cols="6" >
                                            <v-card-text>
                                                <h3>Keywords</h3>
                                            </v-card-text>
                                            <v-combobox
                                                v-model="item.keywords"
                                                hide-selected
                                                hint="Agrega palabras que describan el contenido."
                                                label="Escribe la palabra clave y preciona enter."
                                                multiple
                                                persistent-hint
                                                small-chips
                                                deletable-chips
                                                class="pl-3"
                                                @change="toLowerCase(index1)"
                                            ></v-combobox>
                                        </v-col>
                                        <v-col class="pl-3" cols="4" offset="1">
                                            <v-card-text>
                                                <h3>Mostrar en vista web</h3>
                                            </v-card-text>
                                            <v-switch
                                                v-model="item.showOnWeb"
                                                :label="`${item.showOnWeb === true ? 'Si' : 'No'}`"
                                                class="pl-3"
                                            ></v-switch>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card v-if="item.selectContentType === 'Imagen'">
                            <v-row class="pb-3">
                                <v-col>
                                    <v-row>
                                        <v-col>
                                            <v-card-title>
                                                <h3>Título</h3>
                                            </v-card-title>
                                            <v-row>
                                                <v-col class="mb-4 pl-3 pr-3" cols="8" offset="2">
                                                    <v-text-field
                                                        v-model="item.title"
                                                        name="title"
                                                        label="Agrega el título"
                                                        :counter="max3"
                                                        :rules="[rules.counter3, rules.required]"
                                                        type="text"
                                                        outlined
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-card-title>
                                                <h3>Imagen</h3>
                                            </v-card-title>
                                            <v-row class="mt-4 pb-5" >
                                                <v-col cols="6" offset="3">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on}">
                                                        <v-img
                                                            @click="loadImage(index1)"
                                                            :src="item.imageUrl === '' ? addImageIcon : item.imageUrl"
                                                            height="150"
                                                            contain
                                                            style="cursor:pointer"
                                                            v-on="on"
                                                            eager
                                                        />
                                                    </template>
                                                    <span>{{item.imageUrl === '' ? 'Agregar imagen' : 'Cambiar imagen'}}</span>
                                                </v-tooltip>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <!-- <v-row class="pl-8 pr-8">
                                        <v-col cols="6" >
                                            <v-card-text>
                                                <h3>Keywords</h3>
                                            </v-card-text>
                                            <v-combobox
                                                v-model="item.keywords"
                                                hide-selected
                                                hint="Agrega palabras que describan el contenido."
                                                label="Escribe la palabra clave y preciona enter."
                                                multiple
                                                persistent-hint
                                                small-chips
                                                deletable-chips
                                                class="pl-3"
                                                @change="toLowerCase(index1)"
                                            ></v-combobox>
                                        </v-col>
                                        <v-col class="pl-3" cols="4" offset="1">
                                            <v-card-text>
                                                <h3>Mostrar en vista web</h3>
                                            </v-card-text>
                                            <v-switch
                                                v-model="item.showOnWeb"
                                                :label="`${item.showOnWeb === true ? 'Si' : 'No'}`"
                                                class="pl-3"
                                            ></v-switch>
                                        </v-col>
                                    </v-row> -->
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
                <!-- <v-card v-if="item.selectContentType === 'Video'">
                    <v-layout row wrap pb-3>
                        <v-flex xs12>
                            <v-card-title>
                                <h3>Video</h3>
                            </v-card-title>
                        </v-flex>
                        <v-layout row wrap>
                            <v-flex xs6 offset-xs3 mb-4>
                                <v-img @click="loadVideo(index1)"
                                    :src="item.videoThumbnail"
                                    height="150"
                                    contain
                                    style="cursor:pointer">
                                </v-img>
                            </v-flex>
                            <v-card-text>
                                <h4>Keywords</h4>
                            </v-card-text>
                            <v-flex xs8 pl-3 pr-3 pb-3>
                                <v-combobox
                                    v-model="item.keywords"
                                    hide-selected
                                    hint="Agrega palabras que describan el contenido."
                                    label="Escribe la palabra clave y preciona enter."
                                    multiple
                                    persistent-hint
                                    small-chips
                                    deletable-chips
                                    @change="toLowerCase(index1)"
                                ></v-combobox>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                </v-card> -->
                <!-- <v-card v-if="item.selectContentType === 'Galería'">
                    <v-layout row wrap pb-3>
                        <v-flex xs12>
                        <v-flex xs12>
                            <v-card-title>
                                <h3>Galéría de imágenes</h3>
                            </v-card-title>
                        </v-flex>
                            <v-layout  wrap pb-5 pt-5>
                                <v-content
                                    v-for="(element, index2) in item.gallery"
                                    :key="index2"
                                    class="pa-0"
                                >
                                    <v-hover>
                                        <v-flex xs12 slot-scope="{hover}">
                                            <v-layout row wrap style="position: relative;">
                                                    <v-flex xs10 offset-xs1>
                                                        <v-img @click="loadImage(index1, index2)"
                                                            :src="element.imageUrl"
                                                            height="150"
                                                            contain
                                                            style="cursor:pointer">
                                                        </v-img>
                                                    </v-flex>
                                                    <v-flex xs1>
                                                        <v-btn
                                                            v-show="hover"
                                                            @click="removeGalleryBlock(index1, index2)"
                                                            light
                                                            fab
                                                            small
                                                            absolute
                                                        >X</v-btn>
                                                    </v-flex>
                                                    <v-flex xs10 offset-xs1>
                                                        <v-flex>
                                                            <v-text-field
                                                                v-model="element.title"
                                                                name="gallery-title"
                                                                label="Título"
                                                                id="gallery-title"
                                                                :counter="max3"
                                                                :rules="[rules.counter3, rules.required]"
                                                                type="text"
                                                                required
                                                            ></v-text-field>
                                                        </v-flex>
                                                        <v-flex>
                                                            <v-textarea
                                                                v-model="element.subtitle"
                                                                name="gallery-subtitle"
                                                                label="Subtítulo"
                                                                :counter="max1"
                                                                :rules="[rules.counter1, rules.required]"
                                                                multi-line
                                                                required
                                                            ></v-textarea>
                                                        </v-flex>
                                                    </v-flex>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex xs12 text-xs-right v-show="index2 + 1 === item.gallery.length" >
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{on}">
                                                            <v-btn
                                                                @click="addGalleryImageBlock(index1, index2)"
                                                                dark
                                                                fab
                                                                small
                                                                icon
                                                                color="blue"
                                                                v-on="on"
                                                            ><v-icon>add</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Agregar imagen</span>
                                                    </v-tooltip>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-hover>
                                </v-content>
                            </v-layout>
                        </v-flex>
                        <v-card-text>
                            <h4>Keywords</h4>
                        </v-card-text>
                        <v-flex xs8 pl-3 pr-3 pb-3>
                            <v-combobox
                                v-model="item.keywords"
                                hide-selected
                                hint="Agrega palabras que describan el contenido."
                                label="Escribe la palabra clave y preciona enter."
                                multiple
                                persistent-hint
                                small-chips
                                deletable-chips
                                @change="toLowerCase(index1)"
                            ></v-combobox>
                        </v-flex>
                    </v-layout>
                </v-card> -->
                <v-row justify="center" class="pb-4" v-if="(item.selectContentType) !== '' && (index1 + 1 === flowCmpnts.length)" >
                    <v-tooltip bottom>
                        <template v-slot:activator="{on}">
                            <v-btn
                                @click="addFlowContentBlock(index1)"
                                dark
                                fab
                                small
                                icon
                                :color="mainColor"
                                v-on="on"
                                x-large
                            ><v-icon>{{addIcon}}</v-icon>
                            </v-btn>
                        </template>
                        <span>Agregar contenido</span>
                    </v-tooltip>
                </v-row>
            </v-col>
        </v-row>
    </v-row>
</template>
<script>
import * as constants from '../../../constants.json'
import { mdiPlusCircle, mdiDeleteOutline } from '@mdi/js'

export default {
  props: ['flowComponents', 'rules', 'max1', 'max2', 'max3', 'companyId'],
  data () {
    return {
      flowCmpnts: this.flowComponents, // The knowledge base property sent from the main view.
      pickFile: { index1: null, index2: null }, // Auxiliar index to poit to the actual content block to upload the new content (images, videos).
      mainColor: constants.MAINCOLOR,
      style: {
        border: '1px solid #e1e1e1',
        fontColor: '#525252'
      },
      addImageIcon: constants.ADD_IMAGE_ICON,
      addVideoIcon: constants.ADD_VIDEO_ICON,
      LoadImageDialogProps: { loadDialog: false, imageUrl: null }, // Properties to be sent to the LoadImageDialog component.
      LoadVideoDialogProps: { loadDialog: false, videoUrl: null, videoThumbnail: null }, // Properties to be sent to the LoadVideoDialog component.
      addIcon: mdiPlusCircle,
      deleteIcon: mdiDeleteOutline
    }
  },

  computed: {
    /**
     * Content type options
     */
    contentTypes () {
      return [
        'Imagen',
        'Descripción' // 'Video', // 'Galería'
      ]
    }
  },

  /**
 * Create view and observe data
 */
  created () {
    this.flowCmpnts = this.flowComponents
    // eslint-disable-next-line
        console.log(this.flowCmpnts)
  },

  watch: {
    /**
     * If a new image has been loaded, we add it to the correspondent property.
     */
    'LoadImageDialogProps.imageUrl': function (val) {
      // eslint-disable-next-line
            console.log('this.pickFile', this.pickFile )
      if (this.pickFile.index2 === -1) {
        this.flowCmpnts[this.pickFile.index1].imageUrl = this.LoadImageDialogProps.imageUrl
      } else {
        this.flowCmpnts[this.pickFile.index1].gallery[this.pickFile.index2].imageUrl = this.LoadImageDialogProps.imageUrl
      }
    },

    /**
         * If a new video has been loaded we add it to the correspondent property.
         */
    'LoadVideoDialogProps.videoUrl': function (val) {
      this.flowCmpnts[this.pickFile.index1].videoUrl = this.LoadVideoDialogProps.videoUrl
      this.flowCmpnts[this.pickFile.index1].videoThumbnail = this.LoadVideoDialogProps.videoThumbnail
    }
  },

  methods: {
    /**
         * Adding new content block
         */
    addFlowContentBlock (index) {
      // Don't add anything if there is an empty media content block
      let checkEmptyContent = this.flowCmpnts.filter(content => content.selectContentType === '')
      // eslint-disable-next-line
            console.log(checkEmptyContent.length)
      if (checkEmptyContent.length >= 1) { return }
      if (this.flowCmpnts[index].selectContentType === 'Imagen' && this.flowCmpnts[index].imageUrl === '' && this.flowCmpnts[index].title === '') {
        return
      } else if (this.flowCmpnts[index].selectContentType === 'Video' && this.flowCmpnts[index].videoThumbnail === '') {
        return
      } else if (this.flowCmpnts[index].selectContentType === 'Descripción' && this.flowCmpnts[index].description === '' && this.flowCmpnts[index].title === '') {
        return
      } else if (this.flowCmpnts[index].selectContentType === 'Galería' && this.flowCmpnts[index].gallery[0].imageUrl === '') {
        return
      }
      // Push the elements to flowCmpnts
      this.flowCmpnts.push({
        selectContentType: '',
        description: '',
        gallery: [{
          imageUrl: '',
          title: '',
          subtitle: ''
        }],
        keywords: [],
        imageUrl: '',
        videoUrl: '',
        videoThumbnail: ''
      })
    },

    /**
         * Removing flow content block
         */
    removeFlowBlock (index) {
      if (index === 0 && this.flowCmpnts.length === 1) {
        this.flowCmpnts[0].selectContentType = ''
        this.flowCmpnts[0].description = ''
        this.flowCmpnts[0].gallery = [{
          imageUrl: '',
          title: '',
          subtitle: ''
        }]
        this.flowCmpnts[0].keywords = []
        this.flowCmpnts[0].imageUrl = ''
        this.flowCmpnts[0].videoUrl = ''
        this.flowCmpnts[0].videoThumbnail = ''
      } else {
        this.flowCmpnts.splice(index, 1)
      }
    },

    /**
         * Add a new gallery block
         */
    addGalleryImageBlock (index1, index2) {
      // Don't add anything if there is no selection
      if (this.flowCmpnts[index1].gallery[index2].imageUrl === '') {
        return
      }
      // Push an empty element
      this.flowCmpnts[index1].gallery.push({
        imageUrl: this.addImageIcon,
        title: '',
        subtitle: ''
      })
    },

    /**
         * Removing gallery block
         */
    removeGalleryBlock (index1, index2) {
      if (index2 === 0 && this.flowCmpnts[index1].gallery.length === 1) {
        this.flowCmpnts[index1].gallery[0].imageUrl = ''
        this.flowCmpnts[index1].gallery[0].title = ''
        this.flowCmpnts[index1].gallery[0].subtitle = ''
      } else {
        this.flowCmpnts[index1].gallery.splice(index2, 1)
      }
    },

    toLowerCase (index1) {
      // eslint-disable-next-line
            console.log(this.flowCmpnts[index1].keywords)
      const lowerCase = this.flowCmpnts[index1].keywords.map(keyword => keyword.toLowerCase())
      this.flowCmpnts[index1].keywords = [...lowerCase]
    },

    /**
         * Call the load-image-dialog component
         */
    loadImage (index1, index2 = -1) {
      this.pickFile.index1 = index1
      this.pickFile.index2 = index2
      this.LoadImageDialogProps.loadDialog = true
    },

    /**
         * Call the load-video-dialog component
         */
    loadVideo (index) {
      this.pickFile.index1 = index
      this.LoadVideoDialogProps.loadDialog = true
    }
  }
}
</script>
